import { render, staticRenderFns } from "./CompareLocals.vue?vue&type=template&id=68d14c4f"
import script from "./CompareLocals.vue?vue&type=script&lang=js"
export * from "./CompareLocals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports